import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(
  ) { }

  meses: string[] = ['', 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  dias: string[] = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

  private capitalize(texto: string) {
    return texto.substring(0, 1).toUpperCase() + texto.substring(1);
  }

  today(): Date{
    return new Date();
  }

  todayString(): string {
    return new Date().toISOString().substring(0,16);
  }

  format(date: Date = new Date(), format: string = 'yyyy-mm-dd HH:ii:ss', cleanTimezone: boolean = false): string {
    let result = format;
    
    let data = this.extract(date);

    result = result.replace(/yyyy/g, data.anio.toString());

    try {
      result = result.replace(/MMM/g, this.meses[data.mes].toUpperCase());
      result = result.replace(/Mmm/g, this.capitalize(this.meses[data.mes]));
      result = result.replace(/mmm/g, this.meses[data.mes]);
      result = result.replace(/DDD/g, this.dias[data.diaSemana].toUpperCase());
      result = result.replace(/Ddd/g, this.capitalize(this.dias[data.diaSemana]));
      result = result.replace(/ddd/g, this.dias[data.diaSemana]);

      result = result.replace(/yy/g, data.anio.toString().substring(0, 2));
      result = result.replace(/mm/g, data.mes2);
      result = result.replace(/dd/g, data.dia2);
      result = result.replace(/HH/g, data.hours2);
      result = result.replace(/ii/g, data.minutes2);
      result = result.replace(/ss/g, data.seconds2);

      result = result.replace(/m/g, data.mes.toString());
      result = result.replace(/d/g, data.dia.toString());
      result = result.replace(/H/g, data.hours.toString());
      result = result.replace(/i/g, data.minutes.toString());
      result = result.replace(/s/g, data.seconds.toString());
    } catch (error) {
      return result;
    }

    return result;
  }
  formatDateISO8601(date: Date): string {
    return this.format(date, 'yyyy-mm-dd');
  }

   formatDateISO8601WithTimeAsString(date: Date, time: string): string {
    return this.format(date, 'yyyy-mm-dd ') + time + ':00';
  }


  formatString(dateString: string, format: string = 'yyyy-mm-dd HH:ii:ss'): string {
    let date = new Date(dateString);

    return this.format(date, format);
  }

  extract(date: Date = new Date()): { dia: number, dia2: string, diaSemana: number, mes: number, mes2: string, anio: number, hours: number, hours2: string, minutes: number, minutes2: string, seconds: number, seconds2: string} {
    let dia = date.getDate();
    let dia2 = (dia < 10) ? `0${dia}` : dia.toString();
    let diaSemana = date.getDay();
    let mes = (date.getMonth() - 0) + 1;
    let mes2 = (mes < 10) ? `0${mes}` : mes.toString();
    let anio = date.getFullYear();
    let hours = date.getHours();
    let hours2 = (hours < 10) ? `0${hours}` : hours.toString();
    let minutes = date.getMinutes();
    let minutes2 = (minutes < 10) ? `0${minutes}` : minutes.toString();
    let seconds = date.getSeconds();
    let seconds2 = (seconds < 10) ? `0${seconds}` : seconds.toString();

    return {
      dia,
      dia2,
      diaSemana,
      mes,
      mes2,
      anio,
      hours,
      hours2,
      minutes,
      minutes2,
      seconds,
      seconds2
    };
  }

  addTime(time: string, date: Date = new Date()): Date {
    let data = this.extract(date);
    let modify = time.split(' ');
    let sign = modify[0].substring(0,1);
    let q = parseInt(modify[0].substring(1, modify[0].length));
    if(sign == '-') q = 0 - q;
    let type = modify[1];
    switch (type) {
      case 'day':
        data.dia += q;
        break;
      case 'days':
        data.dia += q;
        break;
      case 'hour':
        data.hours += q;
        break;
      case 'hours':
        data.hours += q;
        break;
      case 'minute':
        data.minutes += q;
        break;
      case 'minutes':
        data.minutes += q;
        break;
      case 'month':
        data.mes += q;
        break;
      case 'months':
        data.mes += q;
        break;
      case 'second':
        data.seconds += q;
        break;
      case 'seconds':
        data.seconds += q;
        break;
      case 'year':
        data.anio += q;
        break;
      case 'years':
        data.anio += q;
        break;
      default:
        break;
    }
    return new Date(data.anio, data.mes -1, data.dia, data.hours, data.minutes, data.seconds)
  }

  dayOfMonth(day: number, date: Date = new Date()): Date {
    let data = this.extract(date);
    return new Date(data.anio, data.mes - 1, day, data.hours, data.minutes, data.seconds)
  }

  lastDayOfMonth(date: Date = new Date()): Date {
    let data = this.extract(date);
    return new Date(data.anio, data.mes, 0, data.hours, data.minutes, data.seconds)
  }

  firstDayOfMonth(date: Date = new Date()): Date {
    let data = this.extract(date);
    return new Date(data.anio, data.mes - 1, 1, data.hours, data.minutes, data.seconds)
  }

  firstDayOfWeek(date: Date = new Date()): Date {
    let data = this.extract(date);
    return new Date(data.anio, data.mes - 1, data.dia - (data.diaSemana == 0 ? 6 : data.diaSemana - 1), data.hours, data.minutes, data.seconds)
  }

  diasDelMes(date: Date = new Date()): number {
    let data = this.extract(this.lastDayOfMonth(date));
    return data.dia;
  }

  dateDiff(fecha1: Date, fecha2: Date, tipo: 'json' | 'days' | 'months' | 'years' | 'hours' | 'seconds' | 'minutes' | 'string' = 'json'): any{
    if(fecha1 > fecha2) {
      let aux = fecha1;
      fecha1 = fecha2;
      fecha2 = aux;
    }
    let data1 = this.extract(fecha1);
    let data2 = this.extract(fecha2);

    let json = {
      years: 0,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }

    json.seconds = data1.seconds - data2.seconds;
    if (json.seconds < 0) {
      json.seconds += 60;
      data1.minutes--;
    }
    json.minutes = data1.minutes - data2.minutes;
    if (json.minutes < 0) {
      json.minutes += 60;
      data1.hours--;
    }
    json.hours = data1.hours - data2.hours;
    if (json.hours < 0) {
      json.hours += 24;
      data1.dia--;
    }
    json.days = data1.dia - data2.dia;
    if (json.days < 0) {
      json.days += this.diasDelMes(fecha1);
      data1.mes--;
    }
    json.months = data1.mes - data2.mes;
    if (json.months < 0) {
      json.months += 12;
      data1.anio--;
    }
    json.years = data1.anio - data2.anio;
    switch (tipo) {
      case 'days':
        var t2 = fecha2.getTime();
        var t1 = fecha1.getTime();

        return Math.floor((t2 - t1) / (24 * 3600 * 1000));
      case 'hours':
        return 0;
      case 'json':
        return 'json';
      case 'minutes':
        return 0;
      case 'months':
        return (json.years * 12) + (json.months);
      case 'seconds':
        return 0;
      case 'string':
        return `${json.years} año${json.years != 1 ? 's' : ''}, ${json.months} mes${json.months != 1 ? 'es' : ''}, ${json.days} día${json.days != 1 ? 's' : ''}, ${json.hours} hora${json.hours != 1 ? 's' : ''}, ${json.minutes} minuto${json.minutes != 1 ? 's' : ''} y ${json.seconds} segundo${json.seconds != 1 ? 's' : ''}`;
      case 'years':
        return (json.years);
      default:
        return 0;
    }
  }

  dateDiffFixed(fecha1: Date, fecha2: Date, tipo: 'json' | 'days' | 'months' | 'years' | 'hours' | 'seconds' | 'minutes' | 'string' = 'json'): any {
    let data1 = this.extract(fecha1);
    let data2 = this.extract(fecha2);

    let json = {
      years: 0,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }

    json.seconds = data1.seconds - data2.seconds;
    if (json.seconds < 0) {
      json.seconds += 60;
      data1.minutes--;
    }
    json.minutes = data1.minutes - data2.minutes;
    if (json.minutes < 0) {
      json.minutes += 60;
      data1.hours--;
    }
    json.hours = data1.hours - data2.hours;
    if (json.hours < 0) {
      json.hours += 24;
      data1.dia--;
    }
    json.days = data1.dia - data2.dia;
    if (json.days < 0) {
      json.days += this.diasDelMes(fecha1);
      data1.mes--;
    }
    json.months = data1.mes - data2.mes;
    if (json.months < 0) {
      json.months += 12;
      data1.anio--;
    }
    json.years = data1.anio - data2.anio;
    switch (tipo) {
      case 'days':
        var t2 = fecha2.getTime();
        var t1 = fecha1.getTime();

        return Math.floor((t2 - t1) / (24 * 3600 * 1000));
      case 'hours':
        return 0;
      case 'json':
        return 'json';
      case 'minutes':
        return 0;
      case 'months':
        return (json.years * 12) + (json.months);
      case 'seconds':
        return 0;
      case 'string':
        return `${json.years} año${json.years != 1 ? 's' : ''}, ${json.months} mes${json.months != 1 ? 'es' : ''}, ${json.days} día${json.days != 1 ? 's' : ''}, ${json.hours} hora${json.hours != 1 ? 's' : ''}, ${json.minutes} minuto${json.minutes != 1 ? 's' : ''} y ${json.seconds} segundo${json.seconds != 1 ? 's' : ''}`;
      case 'years':
        return (json.years);
      default:
        return 0;
    }
  }

  // backend esta en UTC+0, y la API no devuelve con la T ni Z
  // dateStr es yyyy-mm-dd HH:ii:ss
  formatUtcString(dateStr: string): string {
    return `${dateStr.replace(' ', 'T')}Z`;
  }

  // para backend, yyyy-mm-dd HH:ii:ss
  formatDateToUtcBackend(date: Date) {
    return date.toISOString().replace('T', ' ').replace('.000Z', '');
  }

  // recibe un string como 'yyyy-mm-dd' o 'yyyy-mm-dd HH:ii:ss' que indica fecha/hora local
  // y lo ajusta para que sea utc 0
  createUtcDateFromLocalString(dateStr: string) {
    // no olvidar que para 'yyyy-mm-dd' o 'yyyy-mm-dd HH:ii:ss', new Date crea la fecha como si fuera utc 0,
    // y si uno hace print del date le agrega el timezone correspondiente
    // si local es utc - 5, new Date('2024-06-10') haria print 2024-10-09 17:00:00 (-5 Timezone X country)
    const date =  new Date(dateStr);
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  }


  addOffset(date: Date){
    let offset = date.getTimezoneOffset();
    date.setHours(date.getHours() + (offset / 60));
    return date;
  }

  removeOffset(date: Date) {
    let offset = date.getTimezoneOffset();
    date.setHours(date.getHours() - (offset / 60));
    return date;
  }

  // retorna 1, 2, 3, 4 de un date
  calcularQuarter(date: Date): number {
    const mes = date.getMonth() + 1;
    return  Math.ceil(mes / 3);
  }

  // para el q2 y n = 2, retorna 5 (Mayo)
  calcularMesQuarter(quarter: number, mesQuarter: 1|2|3):number {
    return (quarter - 1) * 3 + mesQuarter;
  }

  // https://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  rangoFechasOverlap(startA: Date, endA: Date, startB: Date, endB: Date): boolean {
    return (startA < endB) && (endA > startB);
  }

  agregarQuitarDias(date: Date, dias: number): Date {
    date.setDate(date.getDate() + (dias));
    return date;
  }
}

